import { Container, Row, Col } from "react-bootstrap";
import emo_category_icon from "../../images/emo_category.png";
import FEAI_icon from "../../images/FEAI_icon.png";
import fer2013_sneak_peak from "../../images/fer2013_sneak_peak.png";
import fer2013_distributions from "../../images/fer2013_distributions.png";
import MouseHoverInfoTooltip from "./MouseHoverInfoTooltip";
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import affectnet_sample from "../../images/affectnet_sample.png"
import cover_image from "../../images/Cover Image.png"

import ResNet50ArchitectureTooltip from "./ResNet50ArchitectureTooltip";
import icon_one from "../../images/introPageIcon.png"
import icon_two from "../../images/introPageIcon2.png"
import icon_three from "../../images/introPageIcon3.png"
import icon_step_one from "../../images/step_one.png"
import icon_step_two from "../../images/step_two.png"
import icon_step_three from "../../images/step-three.png"
import icon_step_four from "../../images/step-four.png"
import gradcam_sample from "../../images/gradcam.png";
import guided_gradcam_sample from "../../images/guided_gradcam.png";

import './StudyOneInstruction.css'
import { steps } from "framer-motion";

export default function StudyOneInstructionPageOne(){
    return (
        <Container className="study-item">
            <Row >
                <h1 style={{ fontWeight: 'bold'}}>Welcome !</h1>


            </Row>
            <Row >
            <figure>
                        <img src={cover_image} alt="" style={{width:"100%"}}/>
                </figure>
                </Row>           
        </Container>
    );
};